/**
 * The selpers 'load-more' javascript implementation.
 * @author Mario Sassmann <mario.sassmann@speedy-space.com>
 *
 * @date 2019-06-21 removed most of jquery stuff
 *
 * @TODO: get rid of jquery dependency: replacing $.ajax with fetch()
 */
( function () {

    function loadMore( ajax_action_name, button_noun ) {
        const result_container = document.getElementById( 'results' );
        const button = document.querySelector( '.selpers-loadmore-button' );
        const loader_msg = document.querySelector( '.loader-end-msg' );
        const data = {
            'action': ajax_action_name,
            'query': selpers_loadmore_params.posts,
            'page': selpers_loadmore_params.current_page
        };

        jQuery.ajax( {
            url: selpers_loadmore_params.ajaxurl, // AJAX handler
            data: data,
            type: 'POST',
            beforeSend : function () {
                button.classList.toggle( 'loading' );
            },
            success : function( data ) {
                if ( data ) {
                    // add data to markup
                    result_container.innerHTML += data;

                    button.classList.remove( 'loading' );
                    button.innerText = 'Weitere ' + button_noun;
                    selpers_loadmore_params.current_page++;

                    if ( selpers_loadmore_params.current_page === selpers_loadmore_params.max_page ) {
                        button.style.display = 'none'; // if last page, remove the button
                        loader_msg.style.display = 'inherit';
                    }

                    // you can also fire the "post-load" event here if you use a plugin that requires it
                    jQuery( document.body ).trigger( 'post-load' );
                } else {
                    button.style.display = 'none'; // if no data, remove the button as well
                    loader_msg.style.display = 'inherit';
                }
            }
        } );
    }

    // Event delegation because of dynamically added elements
    document.addEventListener( 'click', function ( event ) {
        if ( event.target.matches( '.loadmore-blog' ) ) {
            loadMore( 'loadmore_blog', 'Artikel' );
        }

        if ( event.target.matches( '.loadmore-minikurs' ) ) {
            loadMore( 'loadmore_minikurs', 'Kurse' );
        }

        if ( event.target.matches( '.loadmore-impulsetools' ) ) {
            loadMore( 'loadmore_impulsetools', 'Tools' );
        }
    }, false ) ;

} ) ();
